import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import { getFranchiseStoreMappedList, getFranchiseUserList } from "../../../services/FranchiseModal/Franchise";

const FranchiseUserMappedList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};

  const [franchiseListUserData, setFranchiseListUserData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchFranchise = () => {
    setLoading(true);
    getFranchiseUserList(brandId, item.id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setFranchiseListUserData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchFranchise();
  }, []);

  const renderCardItem = (data) => {
    return data?.map((franchiseItem, index) => {
       
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Franchise Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem.brandFranchise.name}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Franchise User :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem.user.firstName +
                      " " +
                      franchiseItem.user.lastName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {franchiseItem.status ? "ACTIVE" : "INACTIVE"}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/franchise-user-create", {
                        state: {
                          item: franchiseItem,
                          franchise: item,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    User Mobile No. :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem.user.mobileNo}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Role :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem.user.role}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      User Login Id :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {franchiseItem.user.userLoginId}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/franchise-config-list", {
                      state: {
                        franchiseItem: item,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise's User List
              </p>
            </div>
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() =>
                navigate("/franchise-user-create", {
                  state: {
                    item: null,
                    franchise: item,
                  },
                })
              }
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : franchiseListUserData?.length > 0 ? (
          <div>
            <div>{renderCardItem(franchiseListUserData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Franchise List Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default FranchiseUserMappedList;
